import type { App } from 'vue'
import { inject } from 'vue'

const key = 'app.plugin.facebookAppId'

type IdType = string | undefined

export function providefacebookAppId(app: App, id: IdType): void {
    app.provide(key, id)
}

export function usefacebookAppId(): IdType {
    return inject(key) as IdType
}
